/**
 * Gate global de loading — a resposta à "suruba de loadings".
 *
 * Regra única: alguém está carregando? o gate ABRE (ou continua aberto).
 * Ninguém mais? ele FECHA uma vez, com fade. Cada espera registra uma
 * chave (`begin`/`end`); enquanto houver QUALQUER chave viva, o mesmo
 * BrandLoader fica na tela — nunca um loader fecha pra outro abrir, nunca
 * dois tamanhos diferentes empilham. A legenda mostrada é a da chave mais
 * recente (auth → projeto → cena trocam o texto, não o loader).
 */
import { create } from 'zustand';
import { useEffect } from 'react';

interface LoadingKey {
  key: string;
  caption?: string | null;
}

interface LoadingState {
  keys: LoadingKey[];
  begin: (key: string, caption?: string | null) => void;
  end: (key: string) => void;
}

export const useLoadingStore = create<LoadingState>((set) => ({
  keys: [],
  begin: (key, caption) =>
    set((s) => ({ keys: [...s.keys.filter((k) => k.key !== key), { key, caption }] })),
  end: (key) => set((s) => ({ keys: s.keys.filter((k) => k.key !== key) })),
}));

/**
 * Declarativo: `useLoadingGate('editor-project', isLoading, caption)`.
 * Registra enquanto `active`, solta ao desativar OU desmontar — um
 * componente que morre no meio nunca deixa o gate preso aberto.
 */
export function useLoadingGate(key: string, active: boolean, caption?: string | null) {
  const begin = useLoadingStore((s) => s.begin);
  const end = useLoadingStore((s) => s.end);
  useEffect(() => {
    if (active) begin(key, caption);
    else end(key);
  }, [key, active, caption, begin, end]);
  useEffect(() => () => end(key), [key, end]);
}
